import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "../views/pages/LoginPage";
import PasswordResetPage from "../views/pages/PasswordResetPage";

export default () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgotPassword" element={<PasswordResetPage />} />
      </Routes>
    </BrowserRouter>
  );
};
